// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3UtJV","sendOtp":"AuthorizeToLogin_sendOtp__ND7Al"};